import React from "react";
import { useParams } from "react-router-dom";
import { Box, Flex } from "@chakra-ui/react";

import { useGetUserAppointment } from "modules/user/infrastructure/useGetUserAppointment";

import { WarningWidget } from "components/Widgets";
import { HeaderText } from "components/HeaderText";
import { ChakraText } from "components/ChakraText";

import { ReservationDetails } from "../Commons/ReservationDetails";
import { TimeTable } from "../Reservation/components/TimeTable";
import { EditUserAppointment } from "./EditUserAppointment";

const UserEditAppointment = () => {
  const { appointmentId } = useParams<{
    appointmentId: string;
    friendlyUrl: string;
  }>();
  const { data: appointment } = useGetUserAppointment(appointmentId);

  if (!appointment) {
    return <></>;
  }

  return (
    <Box>
      <HeaderText>Zmiana terminu wizyty</HeaderText>
      <Flex mt={4} justifyContent="center">
        <ChakraText fontWeight="bold">Aktualny termin wizyty</ChakraText>
      </Flex>
      <ReservationDetails appointment={appointment} />

      <Flex mt={8} justifyContent="center">
        <ChakraText fontWeight="bold">Zmień termin wizyty</ChakraText>
      </Flex>
      {appointment.queueId ? (
        <TimeTable
          queueId={appointment.queueId}
          availableDate={appointment.startDate}
        >
          {({ selectedInterval }) => (
            <EditUserAppointment
              appointment={appointment}
              intervalElement={selectedInterval}
            />
          )}
        </TimeTable>
      ) : (
        <WarningWidget>
          <ChakraText fontSize={{ base: "xl", md: "2xl" }} alignSelf="center">Brak możliwości rejestracji terminu</ChakraText>
        </WarningWidget>
      )}
    </Box>
  );
};

export default UserEditAppointment;
